// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__n+oYF","label":"Switch_label__JG4sj","button":"Switch_button__t-glw","isOn":"Switch_isOn__KK+77"};